module.exports = __webpack_public_path__ + "static/media/notification-bell.7c552837.svg";